export default "__VITE_ASSET__BQjvvKV5__"